import borsh from "assets/forArray/borsh.png";
import sup_kurinniy from "assets/forArray/sup_kurinniy.png";
import uha from "assets/forArray/uha.png";
import sup_rybniy from "assets/forArray/sup_rybniy.png";
import sup_harcho from "assets/forArray/sup_harcho.png";
import sup_ovocheviy from "assets/forArray/sup_ovocheviy.png";
import sup_tomatniy from "assets/forArray/sup_tomatniy.png";
import sup_chechevica from "assets/forArray/sup_chechevica.png";
import sup_gribniy from "assets/forArray/sup_gribniy.png";
import solyanka from "assets/forArray/solyanka.png";
import sup_azia from "assets/forArray/sup_azia.png";

import ris from "assets/forArray/ris.png";
import ovochi_gril from "assets/forArray/ovochi_gril.png";
import pure from "assets/forArray/pure.png";
import vareniki from "assets/forArray/vareniki.png";
import fri from "assets/forArray/fri.png";
import ovochi_mix from "assets/forArray/ovochi_mix.png";
import grecha from "assets/forArray/grecha.png";
import ovsyanka from "assets/forArray/ovsyanka.png";
import makarony from "assets/forArray/makarony.png";

import pol_kurcha from "assets/forArray/pol_kurcha.png";
import krilya_bbq from "assets/forArray/krilya_bbq.png";
import kotlety_indeyka from "assets/forArray/kotlety_indeyka.png";
import staik from "assets/forArray/staik.png";
import file_indeyki from "assets/forArray/file_indeyki.png";

import grecheskiy_salat from "assets/forArray/grecheskiy_salat.png";
import frute_salat from "assets/forArray/frute_salat.png";
import brinza_salat from "assets/forArray/brinza_salat.png";
import grecheskiy_krivetki_salat from "assets/forArray/grecheskiy_krivetki_salat.png";
import kapreze_salat from "assets/forArray/kapreze_salat.png";
import cesar_salat from "assets/forArray/cesar_salat.png";

import brauni from "assets/forArray/brauni.png";
import krasniy_oksamit from "assets/forArray/krasniy_oksamit.png";
import yogurt_tort from "assets/forArray/yogurt_tort.png";
import tart from "assets/forArray/tart.png";
import sirniki from "assets/forArray/sirniki.png";
import tri_chokolate from "assets/forArray/tri_chokolate.png";
import shtrudel from "assets/forArray/shtrudel.png";
import bliny from "assets/forArray/bliny.png";

import cola from "assets/forArray/cola.png";
import fanta from "assets/forArray/fanta.png";
import sprite from "assets/forArray/sprite.png";
import beer from "assets/forArray/beer.png";
import water from "assets/forArray/water.png";
import cofe from "assets/forArray/cofe.png";

import hleb from "assets/forArray/hleb.png";
import ketchup from "assets/forArray/ketchup.png";
import tartar from "assets/forArray/tartar.png";
import bbq from "assets/forArray/bbq.png";
import kislo_sladkiy from "assets/forArray/kislo_sladkiy.png";
import sirniy from "assets/forArray/sirniy.png";

const Data = [
  {
    id: 0,
    category: "Перші страви",
    dish: "Уха по-норвезьки",
    description: 400,
    price: 135,
    priceTotal:135,
    count:1,
    img: uha,
  },
  {
    id: 1,
    category: "Перші страви",
    dish: "Куриний суп",
    description: 450,
    price: 70,
    priceTotal:70,
    count:1,
    img: sup_kurinniy,
  },
  {
    id: 2,
    category: "Перші страви",
    dish: "Червоний борщ",
    description: 450,
    price: 100,
    priceTotal:100,
    count:1,
    img: borsh,
  },
  {
    id: 3,
    category: "Перші страви",
    dish: "Тосканьский рибний суп",
    description: 350,
    price: 135,
    priceTotal:135,
    count:1,
    img: sup_rybniy,
  },
  {
    id: 4,
    category: "Перші страви",
    dish: "Суп “Харчо”",
    description: 550,
    price: 110,
    priceTotal:110,
    count:1,
    img: sup_harcho,
  },
  {
    id: 5,
    category: "Перші страви",
    dish: "Овочевий крем суп",
    description: 400,
    price: 100,
    priceTotal:100,
    count:1,
    img: sup_ovocheviy,
  },
  {
    id: 6,
    category: "Перші страви",
    dish: "Томатний крем суп",
    description: 500,
    price: 80,
    priceTotal:80,
    count:1,
    img: sup_tomatniy,
  },
  {
    id: 7,
    category: "Перші страви",
    dish: "Сочевичний крем суп",
    description: 350,
    price: 90,
    priceTotal:90,
    count:1,
    img: sup_chechevica,
  },
  {
    id: 8,
    category: "Перші страви",
    dish: "Грибний крем суп",
    description: 350,
    price: 110,
    priceTotal:110,
    count:1,
    img: sup_gribniy,
  },
  {
    id: 9,
    category: "Перші страви",
    dish: "Солянка",
    description: 500,
    price: 120,
    priceTotal:120,
    count:1,
    img: solyanka,
  },
  {
    id: 10,
    category: "Перші страви",
    dish: "Азіатський суп ",
    description: 400,
    price: 150,
    priceTotal:150,
    count:1,
    img: sup_azia,
  },
  {
    id: 11,
    category: "Гарніри",
    dish: "Рис вершковий",
    description: 230,
    price: 100,
    priceTotal:100,
    count:1,
    img: ris,
  },
  {
    id: 12,
    category: "Гарніри",
    dish: "Овочі гриль",
    description: 500,
    price: 120,
    priceTotal:120,
    count:1,
    img: ovochi_gril,
  },
  {
    id: 13,
    category: "Гарніри",
    dish: "Картопляне пюре",
    description: 400,
    price: 50,
    priceTotal:50,
    count:1,
    img: pure,
  },
  {
    id: 14,
    category: "Гарніри",
    dish: "Вареники з картоплею",
    description: 350,
    price: 80,
    priceTotal:80,
    count:1,
    img: vareniki,
  },
  {
    id: 15,
    category: "Гарніри",
    dish: "Картопля фрі з соусом",
    description: "235/30",
    price: 90,
    priceTotal:90,
    count:1,
    img: fri,
  },
  {
    id: 16,
    category: "Гарніри",
    dish: "Мікс овочів з соусом",
    description: "300/50",
    price: 100,
    priceTotal:100,
    count:1,
    img: ovochi_mix,
  },
  {
    id: 17,
    category: "Гарніри",
    dish: "Гречка с тефтелями",
    description: 300 | 100 | 20,
    price: 110,
    priceTotal:110,
    count:1,
    img: grecha,
  },
  {
    id: 18,
    category: "Гарніри",
    dish: "Вівсяна каша на молоці",
    description: 300,
    price: 50,
    priceTotal:50,
    count:1,
    img: ovsyanka,
  },
  {
    id: 19,
    category: "Гарніри",
    dish: "Макарони з сиром",
    description: "300/50",
    price: 70,
    priceTotal:70,
    count:1,
    img: makarony,
  },
  {
    id: 20,
    category: "М'ясні страви",
    dish: "1/2 Курча",
    description: 400,
    count:1,
    price: 160,
    priceTotal:160,
    img: pol_kurcha,
  },
  {
    id: 21,
    category: "М'ясні страви",
    dish: "Крила BBQ",
    description: 350,
    price: 150,
    priceTotal:150,
    count:1,
    img: krilya_bbq,
  },
  {
    id: 22,
    category: "М'ясні страви",
    dish: "Котлети з індички",
    description: 350,
    price: 120,
    priceTotal:120,
    count:1,
    img: kotlety_indeyka,
  },
  {
    id: 23,
    category: "М'ясні страви",
    dish: "Куряче філе на грилі",
    description: 300,
    price: 130,
    priceTotal:130,
    count:1,
    img: staik,
  },
  {
    id: 24,
    category: "М'ясні страви",
    dish: "Філе індички",
    description: "120/80/30/150",
    price: 190,
    priceTotal:190,
    count:1,
    img: file_indeyki,
  },
  {
    id: 25,
    category: "Салати",
    dish: "Грецький салат ",
    description: 325,
    price: 130,
    priceTotal:130,
    count:1,
    img: grecheskiy_salat,
  },
  {
    id: 26,
    category: "Салати",
    dish: "Фруктовий салат",
    description: 400,
    price: 140,
    priceTotal:140,
    count:1,
    img: frute_salat,
  },
  {
    id: 27,
    category: "Салати",
    dish: "Салат з бринзою",
    description: 350,
    price: 120,
    priceTotal:120,
    count:1,
    img: brinza_salat,
  },
  {
    id: 28,
    category: "Салати",
    dish: "Cалат з креветками",
    description: 380,
    price: 190,
    priceTotal:190,
    count:1,
    img: grecheskiy_krivetki_salat,
  },
  {
    id: 29,
    category: "Салати",
    dish: "Капрезе",
    description: 340,
    price: 160,
    priceTotal:160,
    count:1,
    img: kapreze_salat,
  },
  {
    id: 30,
    category: "Салати",
    dish: "Цезар з куркою",
    description: 400,
    price: 180,
    priceTotal:180,
    count:1,
    img: cesar_salat,
  },
  {
    id: 31,
    category: "Десерти",
    dish: "Фiсташковий брауні",
    description: 250,
    price: 100,
    priceTotal:100,
    count:1,
    img: brauni,
  },
  {
    id: 32,
    category: "Десерти",
    dish: "Червоний оксамит",
    description: 180,
    price: 80,
    priceTotal:80,
    count:1,
    img: krasniy_oksamit,
  },
  {
    id: 33,
    category: "Десерти",
    dish: "Йогуртовий торт",
    description: 260,
    price: 130,
    priceTotal:130,
    count:1,
    img: yogurt_tort,
  },
  {
    id: 34,
    category: "Десерти",
    dish: "Тарт лимонний",
    description: 170,
    price: 80,
    priceTotal:80,
    count:1,
    img: tart,
  },
  {
    id: 35,
    category: "Десерти",
    dish: "Сирники",
    description: 250,
    price: 140,
    priceTotal:140,
    count:1,
    img: sirniki,
  },
  {
    id: 36,
    category: "Десерти",
    dish: "Три шоколада",
    description: 280,
    price: 150,
    priceTotal:150,
    count:1,
    img: tri_chokolate,
  },
  {
    id: 37,
    category: "Десерти",
    dish: "Яблучний штрудель",
    description: 180,
    price: 100,
    priceTotal:100,
    count:1,
    img: shtrudel,
  },
  {
    id: 38,
    category: "Десерти",
    dish: "Млинці з шоколадом",
    description: 280,
    price: 130,
    priceTotal:130,
    count:1,
    img: bliny,
  },
  {
    id: 39,
    category: "Напої",
    dish: "Кока-Кола",
    description: 500,
    price: 40,
    priceTotal:40,
    count:1,
    img: cola,
  },
  {
    id: 40,
    category: "Напої",
    dish: "Фанта",
    description: 500,
    price: 40,
    priceTotal:40,
    count:1,
    img: fanta,
  },
  {
    id: 41,
    category: "Напої",
    dish: "Спрайт",
    description: 500,
    price: 40,
    priceTotal:40,
    count:1,
    img: sprite,
  },
  {
    id: 42,
    category: "Напої",
    dish: "Пиво в асортименті",
    description: 500,
    price: 70,
    priceTotal:70,
    count:1,
    img: beer,
  },
  {
    id: 43,
    category: "Напої",
    dish: "БонАква без газу",
    description: 500,
    price: 30,
    priceTotal:30,
    count:1,
    img: water,
  },
  {
    id: 44,
    category: "Напої",
    dish: "Кава в асортименті",
    description: 400,
    price: 60,
    priceTotal:60,
    count:1,
    img: cofe,
  },
  {
    id: 45,
    category: "Інше",
    dish: "Хлібний кошик",
    description: 300,
    price: 30,
    priceTotal:30,
    count:1,
    img: hleb,
  },
  {
    id: 46,
    category: "Інше",
    dish: "Кетчуп",
    description: 30,
    price: 10,
    priceTotal:10,
    count:1,
    img: ketchup,
  },
  {
    id: 47,
    category: "Інше",
    dish: "Соус Тартар",
    description: 30,
    price: 10,
    priceTotal:10,
    count:1,
    img: tartar,
  },
  {
    id: 48,
    category: "Інше",
    dish: "Соус BBQ",
    description: 30,
    price: 10,
    priceTotal:10,
    count:1,
    img: bbq,
  },
  {
    id: 49,
    category: "Інше",
    dish: "Соус кисло-солодкий",
    description: 30,
    price: 10,
    priceTotal:10,
    count:1,
    img: kislo_sladkiy,
  },
  {
    id: 50,
    category: "Інше",
    dish: "Соус сирний",
    description: 30,
    price: 10,
    priceTotal:10,
    count:1,
    img: sirniy,
  },
];

export default Data;
